import QuizPage from './components/QuizPage';
import { Board } from './components/Board';
import { MGBoardContainer } from "./components/MGBoardContainer";
import {DiceRoller} from "./components/DiceRoller"
import Header from './components/Header';
import { BrowserRouter } from 'react-router-dom';
import { Route,Routes } from 'react-router-dom';
import './App.css';
import GameBoard from "./components/GameBoard"
import { HomePage } from './components/HomePage';
function App() {
  return (
    <div id="site-container">
      <BrowserRouter>
      
        <Header></Header>
        <div className="main-wrapper">
        <Routes>
        <Route path="/" element={ <HomePage></HomePage>}>
          </Route>
        <Route path="/match-2-game" element={ <MGBoardContainer></MGBoardContainer>}>
          </Route>
          <Route path="/calc-quiz" element={ <QuizPage></QuizPage>}>
          </Route>
          <Route path="/elevens-game" element={ <Board></Board>}>
          </Route>
         
           <Route path="/space-shooter" element={ <div className="game-page-container">
            <GameBoard></GameBoard>
           
            <div className="iframe-wrapper">
            <h2>Original Vanilla JS Version: <a href="https://mack64948.github.io">Alien Sniper Defense</a> </h2>
            <iframe className="iframe-container" src="https://mack64948.github.io"></iframe>
            </div>
         
          </div>}>
          </Route>
          <Route path="/board-game" element={ 
            <DiceRoller></DiceRoller>
          }>
           
          </Route>

        </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
